var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{style:(_vm.style),attrs:{"x":_vm.shape.x,"y":_vm.shape.y,"width":_vm.shape.width,"height":_vm.shape.height}})}
var staticRenderFns = []

export { render, staticRenderFns }